import { Cookies } from 'react-cookie';
import axios from 'axios';

import { API_BASE_URL, environment } from '../constants';

type Environments = keyof typeof API_BASE_URL;

axios.defaults.baseURL = API_BASE_URL[environment as Environments];

axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['cache-control'] = 'no-cache';

axios.interceptors.request.use(config => {
  const token = new Cookies().get('accessToken');
  if (token) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
export { axios };
